import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { weeklyCalendar, todayWeekday } from '@/mocks/calendar';

export default function CalendarPreview() {
  return (
    <section id="calendar" className="w-full scroll-mt-24 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="Calendar"
          title="本周追剧日历"
          desc="一周七天的更新安排一眼看完，哪天更新哪部、更到第几集，全部按连续剧集更新顺序排列。"
          actionText="打开完整日历"
          actionTo="/calendar"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7">
          {weeklyCalendar.map((day) => {
            const isToday = day.weekday === todayWeekday;
            return (
              <div
                key={day.weekday}
                className={`rounded-lg border p-4 ${
                  isToday
                    ? 'border-primary-400 bg-background-50'
                    : 'border-background-200 bg-background-50/70'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className={`font-heading text-sm font-bold ${isToday ? 'text-primary-600' : 'text-foreground-900'}`}>
                    {day.label}
                  </span>
                  {isToday && (
                    <span className="rounded-md bg-primary-500 px-1.5 py-0.5 text-[10px] text-background-50">今天</span>
                  )}
                </div>
                <p className="mt-1 text-xs text-foreground-400">{day.date.slice(5).replace('-', '/')}</p>
                <ul className="mt-3 space-y-2">
                  {day.items.map((item) => (
                    <li key={`${day.weekday}-${item.dramaId}`}>
                      <Link
                        to={`/drama/${item.dramaId}`}
                        className="block cursor-pointer rounded-md bg-background-100 px-2.5 py-2 transition-colors hover:bg-accent-100"
                      >
                        <span className="block truncate text-xs text-foreground-900">{item.dramaTitle}</span>
                        <span className="mt-0.5 flex items-center justify-between text-[11px] text-foreground-500">
                          <span>{item.range}</span>
                          <span className="text-accent-700">{item.time}</span>
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}